export const SET_JWT_DATA = "SET_JWT_DATA"; //eslint-disable-line
export type SET_JWT_DATA = typeof SET_JWT_DATA; //eslint-disable-line